import { useEffect } from "react";
import { useAuth } from "@/auth/AuthProvider";
import {
  CONSOLE_REDESIGN_ATTR,
  CONSOLE_REDESIGN_FLAG,
} from "@/lib/consoleRedesign";

/**
 * Whether the console_experience_redesign flag is enabled for this session.
 * Defaults to false when the flag is absent, so flag-off renders today's shell.
 */
export function useConsoleRedesignEnabled(): boolean {
  const { featureFlags } = useAuth();
  return featureFlags?.[CONSOLE_REDESIGN_FLAG] === true;
}

/**
 * Mirrors the redesign flag onto `data-console-redesign` on the document
 * element so the F65 token overrides and shell apply. Pure in `enabled` for
 * testability; the attribute is removed on cleanup and when the flag is off.
 */
export function useConsoleRedesignAttribute(enabled: boolean): void {
  useEffect(() => {
    if (typeof document === "undefined") return;
    const root = document.documentElement;
    if (enabled) {
      root.setAttribute(CONSOLE_REDESIGN_ATTR, "true");
    } else {
      root.removeAttribute(CONSOLE_REDESIGN_ATTR);
    }
    return () => {
      root.removeAttribute(CONSOLE_REDESIGN_ATTR);
    };
  }, [enabled]);
}
